/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ since: NonNullable<unknown> }} Fulfillment_Waiting_On_CancellationInputs */

const en_fulfillment_waiting_on_cancellation = /** @type {(inputs: Fulfillment_Waiting_On_CancellationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Waiting on the warehouse · cancellation · since ${i?.since}`)
};

/**
* | output |
* | --- |
* | "Waiting on the warehouse · cancellation · since {since}" |
*
* @param {Fulfillment_Waiting_On_CancellationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const fulfillment_waiting_on_cancellation = /** @type {((inputs: Fulfillment_Waiting_On_CancellationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fulfillment_Waiting_On_CancellationInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fulfillment_waiting_on_cancellation(inputs)
});